var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilenew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#26801E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5682_3818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.364 6.63602C17.6641 4.93621 15.4039 4 13 4C10.5961 4 8.33589 4.93618 6.63602 6.63602C4.93621 8.33589 4 10.5961 4 13C4 15.4039 4.93618 17.6641 6.63602 19.364C8.33589 21.0638 10.5961 22 13 22C15.4039 22 17.6641 21.0638 19.364 19.364C21.0638 17.6641 22 15.4039 22 13C22 10.5961 21.0638 8.33589 19.364 6.63602ZM7.90604 19.0925C8.20325 16.5354 10.4017 14.5612 13 14.5612C14.3697 14.5612 15.6577 15.0948 16.6266 16.0636C17.4451 16.8822 17.9613 17.951 18.0941 19.0923C16.7139 20.2482 14.9369 20.9453 13 20.9453C11.0631 20.9453 9.2862 20.2484 7.90604 19.0925ZM13 13.4749C11.4928 13.4749 10.2665 12.2485 10.2665 10.7414C10.2665 9.23403 11.4929 8.00781 13 8.00781C14.5071 8.00781 15.7335 9.23403 15.7335 10.7414C15.7335 12.2485 14.5072 13.4749 13 13.4749V13.4749ZM19.0018 18.2008C18.7309 17.1095 18.1675 16.1128 17.3723 15.3179C16.7241 14.6696 15.9572 14.1834 15.1209 13.8786C16.1263 13.1968 16.7882 12.0449 16.7882 10.7414C16.7882 8.65258 15.0888 6.95312 13 6.95312C10.9112 6.95312 9.21177 8.65258 9.21177 10.7414C9.21177 12.0456 9.87426 13.1979 10.8805 13.8796C10.111 14.16 9.39898 14.5936 8.78635 15.1643C7.89918 15.9905 7.28314 17.0439 6.99749 18.2C5.78777 16.8054 5.05469 14.9867 5.05469 13C5.05469 8.61893 8.61893 5.05469 13 5.05469C17.3811 5.05469 20.9453 8.61893 20.9453 13C20.9453 14.9871 20.212 16.8062 19.0018 18.2008Z",
    fill: "#FDF9E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5682_3818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilenew);
export default __webpack_public_path__ + "static/media/profilenew.8939aaa17e886f6ec8d527ab42c79b0d.svg";
export { ForwardRef as ReactComponent };